/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/3/22
 */

import React from "react";
import {
	Stack,
} from "@mui/material";
import CalendarActions from "./CalendarActions";
import CalendarHeader from "./CalendarHeader";
import {useQuery} from "urql";
import {SavedCalendarQuery, SavedCalendarQueryVars, SavedCalendarResponse} from "../graphql/queries/calendars";
import {useSelector} from "react-redux";
import {State} from "../state/store";
import { defaultSettings } from "../state/reducers/settings";

export default function CalendarControls() {

	const stateCalendar = useSelector((s:State) => s.calendar);

	const [savedCalendarResult ] = useQuery<SavedCalendarResponse, SavedCalendarQueryVars>({
		query: SavedCalendarQuery,
		pause: stateCalendar.id === 0,
		variables: { id: stateCalendar.id }
	});

	const filter = useSelector((s:State) => s.employeesFilter);
	const settings = useSelector((s:State) => s.settings);

	const savedCalendar = savedCalendarResult.data?.savedCalendar;
	const savedCalendarSettingsFull = React.useMemo(() => ({ ...defaultSettings, ...(savedCalendar?.config?.settings || {}) } as Record<string, any>),
		[savedCalendar?.config?.settings]);

	const unsavedChanges = React.useMemo(() => {
		return !!stateCalendar.id && (stateCalendar.title !== savedCalendar?.title
			|| JSON.stringify(filter) !== JSON.stringify(savedCalendar?.config?.employeesFilter)
			|| Object.entries(settings).some(([e, v]) => JSON.stringify(savedCalendarSettingsFull[e]) !== JSON.stringify(v)))
	}, [filter, savedCalendar?.config?.employeesFilter, savedCalendar?.title, savedCalendarSettingsFull, settings, stateCalendar.id, stateCalendar.title]);

	return (
		<Stack direction={"row"} spacing={1} alignItems={"center"}>
			<CalendarHeader
				savedCalendar={savedCalendar}
				unsavedChanges={unsavedChanges}
			/>
			<CalendarActions
				savedCalendar={savedCalendar}
				unsavedChanges={unsavedChanges}
			/>
		</Stack>
	);

}



